import React from 'react'

import SiteContainer from '../../Containers/SiteContainer/SiteContainer'
import AnimatedBlob from '../../Components/AnimatedBlob/AnimatedBlob'
import BackDrop from '../../Components/BackDrop/BackDrop'
import Content from '../../Components/Content/Content'
import Button from '../../Components/Button/Button'
import Columns from '../../Components/Columns/Columns'
import Divider from '../../Components/Divider/Divider'
import Hero from '../../Components/Hero/Hero'
import Spacer from '../../Components/Spacer/Spacer'
import './ServicesPage.css'

const ServicesPage = () => {
  return (
    <SiteContainer className="fmbm-services">
      <Hero title="Services" modifiers={['fmbm-hero--center']}>
        <div className="fmbm-hero__small-text wow fadeIn">
          See what products and services we offer
        </div>
      </Hero>
      <Content>
        <Spacer />
        <h1 align="center">3 Ways to get Started</h1>
        <Spacer />
        <Columns number={3}>
          <div>
            <h2>Rent a Team</h2>
            <p>
              Suitable for start-ups & agencies who would like to partner with
              us and scale their tech team, without the worries of HR,
              recruiting, or having to manage a team of engineers & designers.
              Pricing is fixed per month and requires a commitment.
            </p>
            <Button
              href="https://goo.gl/forms/AsWL9cTL9gWKhzis2"
              buttonText="Rent a Team"
            />
          </div>
          <div>
            <h2>Start a Project</h2>
            <p>
              Looking to go from idea to MVP? This is suitable for start-ups,
              agencies & even individuals, during the prototyping phase. Pricing
              is fixed hourly. This service requires a fixed scope &
              documentation. If you have none, we typically suggest scheduling a
              consultation session, so that we can help you scope out your
              project.
            </p>
            <Button
              buttonText="Start a Project"
              href="https://goo.gl/forms/X6ELfpPVh4pcH0IM2"
            />
          </div>
          <div>
            <h2>Schedule Consultation</h2>
            <p>
              Have an idea of the problem you're trying to solve, but not sure
              where to begin? Schedule a consultation call and chat with a
              senior engineer & product specialist, who can help you meet your
              goals. Pricing is fixed hourly and requires no commitment.
            </p>
            <Button
              buttonText="Schedule Consultation"
              href="https://goo.gl/forms/2xKpzi3kimIdSFGW2"
            />
          </div>
        </Columns>
      </Content>
      <Divider />
      <Content>
        <Columns number={2}>
          <div>
            <BackDrop>
              <img
                alt="Hang - Mobile App"
                src={require('./img/hang-app-screenshot.png')}
              />
            </BackDrop>
          </div>
          <div>
            <h1>Mobile Applications</h1>
            <p>
              We specialize in both iOS & Android mobile apps. From design to
              development, we've got you covered with all angles. Looking for a
              tablet app? We can do that, too.
            </p>
            <Button
              buttonText="Build an app"
              href="https://goo.gl/forms/X6ELfpPVh4pcH0IM2"
            />
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile />
      </Content>
      <Divider />
      <Content>
        <Columns number={2} disableReverse>
          <div>
            <h1>Web Applications & Design</h1>
            <p>
              Whether you're looking for a completely custom web application, or
              would like to further your own, we can make that happen! We work
              with a number of different software and frameworks as well, so
              feel free to reach out and see if we can help.
            </p>
            <Button
              buttonText="Build a web app"
              href="https://goo.gl/forms/X6ELfpPVh4pcH0IM2"
            />
          </div>
          <div>
            <BackDrop color="purple">
              <img alt="" src={require('./img/gist-web-app.png')} />
            </BackDrop>
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile right />
      </Content>
      <Divider />
      <Content>
        <Columns number={2}>
          <div>
            <BackDrop>
              <img
                alt="Thrifter's Deals CMS"
                src={require('./img/thrifter-deals-cms.png')}
              />
            </BackDrop>
          </div>
          <div>
            <h1>CMS/Software Customization</h1>
            <p>
              We work with a number of CMS's & platforms, including Drupal,
              Wordpress, vBulletin, Joomla, Shopify, Woocommerce, XenForo &
              more.
            </p>
            <p>
              We cover all angles of these software, including new functionality
              or custom designs - all tailored to your specific needs.
            </p>
            <Button
              href="https://goo.gl/forms/X6ELfpPVh4pcH0IM2"
              buttonText="Customize my software"
            />
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile />
      </Content>
      <Divider />
      <Content>
        <Columns number={2} disableReverse>
          <div>
            <h1>Backend Systems</h1>
            <p>
              Serverless computing, Restfull API's, AWS management, database
              architecture & more, are just some of the backend assistance we
              offer.
            </p>
            <p>
              Our team is completely full-stack, meaning we can truly cover all
              angles of your app, from frontend to backend.
            </p>
            <Button
              href="https://goo.gl/forms/X6ELfpPVh4pcH0IM2"
              buttonText="Backend Development"
            />
          </div>
          <div>
            <BackDrop color="purple">
              <img
                alt=""
                src="https://firebasestorage.googleapis.com/v0/b/fmbm-f5989.appspot.com/o/workpics%2Fmishall-mike-problem-solving.png?alt=media&token=81626d88-9cad-4f5d-b9d5-86c70424e603"
              />
            </BackDrop>
          </div>
        </Columns>
        <AnimatedBlob hiddenMobile right />
      </Content>
      <Spacer />
      <Divider />
    </SiteContainer>
  )
}
export default ServicesPage



// WEBPACK FOOTER //
// ./src/Pages/Services/ServicesPage.js